<template>
  <div>
    <el-alert type="info" show-icon :closable="false" style="margin-bottom:12px"
      title="班次目前用于基础资料维护；自动排程尚未按班次时段计算。" />
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="班次编码"><el-input v-model="query.code" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="班次名称"><el-input v-model="query.name" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="车间">
        <el-select v-model="query.workShopId" clearable filterable size="small" style="width:120px">
          <el-option v-for="item in shops" :key="item.workShopId" :label="item.workShopName" :value="item.workShopId" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('base:workShift:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('base:workShift:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="shiftCode" label="班次编码" min-width="100">
        <template slot-scope="scope">
          <span v-if="isAuth('base:workShift:info') || isAuth('base:workShift:list')" class="code-link" @click="open(scope.row.workShiftId, true)">{{ scope.row.shiftCode }}</span>
          <span v-else>{{ scope.row.shiftCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="shiftName" label="班次名称" min-width="100" />
      <el-table-column label="适用车间" min-width="100"><template slot-scope="scope">{{ scope.row.workShopName || '全厂' }}</template></el-table-column>
      <el-table-column label="时段" min-width="120"><template slot-scope="scope">{{ timeRange(scope.row) }}</template></el-table-column>
      <el-table-column prop="lineSort" label="排序" width="60" />
      <el-table-column label="状态" width="70" align="center">
        <template slot-scope="scope"><el-tag :type="scope.row.isenabled === '0' ? 'success' : 'danger'" size="mini">{{ scope.row.isenabled === '0' ? '启用' : '禁用' }}</el-tag></template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />
    <work-shift-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import WorkShiftAddOrUpdate from './workShift-add-or-update'

export default {
  name: 'WorkShift',
  components: { WorkShiftAddOrUpdate },
  data() {
    return {
      query: { code: '', name: '', workShopId: '' }, shops: [], list: [], pageIndex: 1, pageSize: 20, loading: false, hasActivated: false,
      addOrUpdateVisible: false, permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  computed: {
    total() { return this.list.length },
    pageList() { return this.list.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.loadShops(); this.load() },
  activated() {
    if (this.hasActivated) { this.loadShops(); this.load() }
    else this.hasActivated = true
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    loadShops() { request.post('/base/workShop/list', { currentPage: 1, pageSize: 500 }).then(res => { this.shops = (res.data && res.data.list) || [] }).catch(() => {}) },
    timeRange(row) {
      if (!row.startTime && !row.endTime) return ''
      return (row.startTime || '') + ' - ' + (row.endTime || '')
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/production/workShift/list', { params: this.query }).then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    open(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(id, !!readonly, { workShopId: this.query.workShopId || '' }))
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
</style>
